import { createContext } from "react";
const OrgContext = createContext({});

export default OrgContext;
